module.exports = __webpack_public_path__ + "img/logo.0b1ba234.png";